import api from '@/services/api';
import { ContentFilters } from '../listening/types';
import {
    GrammarContent,
    GrammarSession,
    CreateGrammarSessionRequest,
    CompleteGrammarSessionRequest,
} from './types';

const grammarService = {
    getGrammarContents: async (filters?: ContentFilters) => {
        const params = new URLSearchParams();

        if (filters) {
            Object.entries(filters).forEach(([key, value]) => {
                if (value !== undefined && value !== null && value !== '') {
                    params.append(key, value.toString());
                }
            });
        }
        const response = await api.get(`/grammar/contents/?${params}`);
        return response.data;
    },

    // Content Management
    getGrammarContent: async (id: string): Promise<GrammarContent> => {
        const response = await api.get(`/grammar/contents/${id}/`);
        return response.data;
    },

    getGrammarContentByPrimaryId: async (primary_content_id: string): Promise<GrammarContent> => {
        const response = await api.get(`/grammar/contents/primary/${primary_content_id}/`);
        return response.data;
    },

    // Session Management
    startGrammarSession: async (sessionConfig: CreateGrammarSessionRequest): Promise<GrammarSession> => {
        const response = await api.post('/grammar/sessions/create/', sessionConfig);
        return response.data;
    },

    getGrammarSession: async (sessionId: string): Promise<GrammarSession> => {
        const response = await api.get(`/grammar/sessions/${sessionId}/`);
        return response.data;
    },

    submitGrammarAnswer: async (sessionId: string, data: any) => {
        const response = await api.post(`/grammar/sessions/${sessionId}/submit/`, data);
        return response.data;
    },

    // Progress and Feedback
    getSessionProgress: async (sessionId: string) => {
        const response = await api.get(`/grammar/sessions/${sessionId}/progress/`);
        return response.data;
    },

    getSessionFeedback: async (sessionId: string) => {
        const response = await api.get(`/grammar/sessions/${sessionId}/feedback/`);
        return response.data;
    },

    generateFeedback: async (sessionId: string) => {
        const response = await api.post(`/grammar/sessions/${sessionId}/generate-feedback/`);
        return response.data;
    },

    // Session Completion
    completeGrammarSession: async (sessionId: string, data: CompleteGrammarSessionRequest): Promise<GrammarSession> => {
        const response = await api.post(`/grammar/sessions/${sessionId}/complete/`, data);
        return response.data;
    },
};

export default grammarService;
